// extracted by mini-css-extract-plugin
module.exports = {"main":"FixedBanner_main__ItN8u","confirmDelete":"FixedBanner_confirmDelete__z257w","deleteDialog":"FixedBanner_deleteDialog__Eb9OC","description":"FixedBanner_description__5iwIO"};